import React from 'react'
import { Logo } from '../components/Logo'
import { ComidaDay } from './ComidaDay'
import { MenuDayOption } from './MenuDayOption'

export const MenuUnificadoDayOnline = () => {
  return (
    <div className="App">
      <Logo></Logo>
      <MenuDayOption></MenuDayOption>
    </div>
  )
}
